import React from 'react';
import bespokeServerAppMockups3Html from './bespokeServerAppMockups3Html';

const BespokeServerAppMockups3: React.FC = () => {
  return (
    <iframe
      srcDoc={bespokeServerAppMockups3Html}
      title="Bespoke Server App — Style Explorations III"
      style={{ width: '100%', height: '100vh', border: 'none' }}
    />
  );
};

export default BespokeServerAppMockups3;
